

import { SWRConfiguration, SWRResponse } from 'swr';
import { AuthenticateResponse, Authenticate } from '@/api/dtos';
import useGet from '../api/useGet';

const request = () => {
    return new Authenticate();
};

const getData = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => response?.data;
const getError = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => ({
    isBctStaff: !!response?.data?.roles?.includes("BctStaff"),
    isAdmin: !!response?.data?.roles?.includes("Admin"),
    isMedicalReviewer: !!response?.data?.roles?.includes("MedicalReviewer"),
    isCentralScientist: !!response?.data?.roles?.includes("CentralScientist")
});

export const useAuthenticatedUser = (configuration: SWRConfiguration) => {
    return useGet(request, { getData, getError, getAdditionalState }, configuration);
};

export default useAuthenticatedUser;